export default __webpack_public_path__ + "static/media/amazon-logo-white-png-transparent-3.668d6f2c.png";